import React, { useState } from 'react';
//components
import Text from 'components/Text';
import Input from 'components/Input';
import Modal from '../generics/Modal';
import { Button } from 'components/Button';
import { Visibility } from 'components/Visibility';
import { Buttons, OrderReportButtonContent, OrderReportModal, Title } from './styles';
//assets
import DownloadIcon from "img/money-queue-success.svg";
import DownloadTechnicalSheetBtn from "img/download-technical-sheet.svg";

export const OrderReportButton: React.FC<any> = (props) => {
  const {

  } = props;

  const [openModal, setOpenModal] = useState(false);

  const modalContent = (
    <OrderReportModal>
      <img src={DownloadIcon} className='modalIcon' />
      <Title>Baixar espelho do pedido</Title>
      <p>Faça o download do espelho do pedido selecionando os formatos abaixo:</p>
      <Buttons>
        <div className='flex-column align-center justify-center d-flex'>
          <Button>
            <img src={DownloadTechnicalSheetBtn} />
          </Button>
          <label>PDF</label>
        </div>
        <div className='flex-column align-center justify-center d-flex'>
          <Button>
            <img src={DownloadTechnicalSheetBtn} />
          </Button>
          <label>CSV</label>
        </div>
      </Buttons>
      <hr />
      <p>Se desejar, selecione para qual e-mail o espelho do pedido deve ser enviado (formato PDF):</p>
      <Input type='text' placeholder='exemplo@email.com.br' />
      <Buttons>
        <div className='labelColor'>
          <Button onClick={() => setOpenModal(false)}>Cancelar</Button>
        </div>
        <div className='sendButton'>
          <Button>Enviar</Button>
        </div>
      </Buttons>
    </OrderReportModal>
  );

  const downloadButton = (
    <Button
      onClick={() => setOpenModal(true)}
      className={`btnDown`}>
      <img src={DownloadTechnicalSheetBtn} />
      <Text className='font-bold px-3'>Baixar espelho</Text>
    </Button>
  );

  return (
    <OrderReportButtonContent>
      {downloadButton}
      <Visibility visible={openModal}>
        <Modal>
          {modalContent}
        </Modal>
      </Visibility>

    </OrderReportButtonContent>
  );
};
